import { VcsProvider } from "types/generated";

export const checkWithMultipleVCSIntegrations = (provider?: VcsProvider): boolean => {
  return (
    provider === VcsProvider.GithubEnterprise ||
    provider === VcsProvider.AzureDevops ||
    provider === VcsProvider.Gitlab ||
    provider === VcsProvider.BitbucketCloud ||
    provider === VcsProvider.BitbucketDatacenter ||
    provider === VcsProvider.Blob
  );
};

// Blob Storage reads source archives from an object store: there is no VCS host,
// so commits and branches have nothing to link to.
export const providerHasVcsHost = (provider?: VcsProvider): boolean =>
  provider !== VcsProvider.Blob;

// Raw Git has no webhooks, and Blob Storage has no pushes at all: its runs come
// from the HEAD pointer moving or from a manual trigger.
export const providerHasPushEvents = (provider?: VcsProvider): boolean =>
  provider !== VcsProvider.Git && provider !== VcsProvider.Blob;

// A provider whose sources are addressed by a commit hash, which is what makes shortening
// a commit to a fixed number of digits safe. Blob Storage tracks a free-form archive name
// instead, so there is nothing to shorten.
export const providerHasCommitHashes = (provider?: VcsProvider): boolean =>
  provider !== VcsProvider.Blob;
